// extracted by mini-css-extract-plugin
module.exports = {"CarouselSlickVertical":"CarouselSlick_CarouselSlickVertical__Ff6xM"};